import { ComponentCmsDataFormQuestion } from "@/generated";
import { useState } from "react";

interface OtherOptionButtonProps {
  question: ComponentCmsDataFormQuestion;
  setIsOtherSelected: (isSelected: boolean) => void;
  setInputValue: (value: string) => void;
  isTransparent?: boolean;
}

export const OtherOptionButton: React.FC<OtherOptionButtonProps> = ({
  question,
  setIsOtherSelected,
  setInputValue,
  isTransparent,
}) => {
  const [showInput, setShowInput] = useState(false);
  const [localInputValue, setLocalInputValue] = useState("");

  const handleClick = () => {
    setShowInput(true);
    setIsOtherSelected(true);
  };

  const handleFocusOut = () => {
    if (!localInputValue) {
      setShowInput(false);
      setIsOtherSelected(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalInputValue(value);
    setInputValue(value);
  };

  return (
    <div className="w-full">
      {!showInput ? (
        <button
          onClick={handleClick}
          className="w-full p-4 text-left rounded-lg transition-colors"
          style={
            isTransparent
              ? {
                  backgroundColor: `${question.submit_button_color || "#13235b"}50`,
                  color: question.submit_button_text_color || "white",
                  boxSizing: "border-box",
                  border: `2px solid ${question.submit_button_color || "#13235b"}`,
                }
              : {
                  backgroundColor: question.submit_button_color || "#13235b",
                  color: question.submit_button_text_color || "white",
                }
          }
        >
          Other
        </button>
      ) : (
        <input
          type="text"
          style={
            isTransparent
              ? {
                  backgroundColor: `${question.submit_button_color || "#13235b"}50`,
                  color: question.submit_button_text_color || "white",
                  boxSizing: "border-box",
                  border: `2px solid ${question.submit_button_color || "#13235b"}`,
                }
              : {
                  backgroundColor: question.submit_button_color || "#13235b",
                  color: question.submit_button_text_color || "white",
                }
          }
          value={localInputValue}
          onChange={handleInputChange}
          onBlur={handleFocusOut}
          placeholder="Type your answer"
          className="w-full p-4 border rounded-lg"
          autoFocus
        />
      )}
    </div>
  );
};
